import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const socialLinks = [
    { icon: 'fab fa-linkedin-in', url: 'mailto:melgar@polymath.com?subject=Professional%20Inquiry', label: 'Professional Inquiry' },
    { icon: 'fas fa-lightbulb', url: 'mailto:melgar@polymath.com?subject=Share%20Insights', label: 'Share Insights' },
    { icon: 'fas fa-microphone', url: 'mailto:melgar@polymath.com?subject=Media%20Request', label: 'Media Request' },
    { icon: 'fas fa-handshake', url: 'mailto:melgar@polymath.com?subject=Collaboration', label: 'Collaboration' }
  ];

  return (
    <section id="hero" className="hero-section" ref={ref}>
      <div className="container">
        <div className="hero-content">
          <div className={`hero-left ${inView ? 'fade-in' : ''}`}>
            <h1 className="hero-name">MELGAR GULTIANO</h1>
            <p className="hero-subtitle">The Polymath Executive: Interdisciplinary Powerhouse</p>
            <p className="hero-description">
              An executive powerhouse with credentials spanning CPA, CIA, CFE, CISA, CC, GRCP, GRCA, and IPMP. 
              Delivering strategic guidance through 360-degree interdisciplinary expertise in Finance, Governance, 
              Risk, Compliance, Audit, Advisory, and Business Excellence.
            </p>
            
            <div className="cta-buttons">
              <Link to="/services" className="btn btn-primary">
                <i className="fas fa-briefcase"></i>
                View Services
              </Link>
              <Link to="/about" className="btn btn-secondary">
                <i className="fas fa-user"></i>
                About Me
              </Link>
            </div>

            <div className="social-icons">
              {socialLinks.map((link, index) => (
                <a 
                  key={index}
                  href={link.url} 
                  className="social-link" 
                  aria-label={link.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={link.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className={`hero-right ${inView ? 'fade-in' : ''}`}>
            <div className="portrait-container">
              <div className="triangle-frame"></div>
              <div className="portrait-image">
                <img 
                  src="/Melgar_Profile.png" 
                  alt="Melgar Gultiano - Professional Portrait"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

